import { Plugin } from '@nuxt/types'
import ggoApi from '~/modules/ggo-api'

// 在 nuxt plugin 加上改 ggo-api locale 邏輯, 不只有依賴 language switcher 的 watch effect
export default (({ i18n }) => {
  ggoApi.setLocale(i18n.locale)
}) as Plugin
